import { Camera, CheckSquare, PlayCircle, Type, type LucideIcon } from 'lucide-react';
import type { TaskType } from '@/store/templatesSlice';

export type ChipColor = 'default' | 'accent' | 'success' | 'warning' | 'danger';

export const TASK_TYPE_LABELS: Record<TaskType, string> = {
  photo: 'Фото',
  text_input: 'Текст',
  checkbox: 'Да / Нет',
  action: 'Действие',
};

export const TASK_TYPE_DESCRIPTIONS: Record<TaskType, string> = {
  photo: 'Исполнитель загружает фотографии (с ИИ-анализом)',
  text_input: 'Исполнитель вводит текстовый ответ',
  checkbox: 'Ответ «Да» или «Нет»',
  action: 'Шаг без сбора данных — выполняется вне приложения, затем «Далее»',
};

export const TASK_TYPE_ICONS: Record<TaskType, LucideIcon> = {
  photo: Camera,
  text_input: Type,
  checkbox: CheckSquare,
  action: PlayCircle,
};

export const TASK_TYPE_COLORS: Record<TaskType, ChipColor> = {
  photo: 'warning',
  text_input: 'accent',
  checkbox: 'success',
  action: 'default',
};

export const TASK_TYPE_OPTIONS: { id: TaskType; label: string }[] = [
  { id: 'photo', label: 'Фото' },
  { id: 'text_input', label: 'Текст' },
  { id: 'checkbox', label: 'Да / Нет' },
  { id: 'action', label: 'Действие' },
];
